import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadersModule } from '../headers/raksme.headerModule';
import { BreadcrumbModule } from 'angular-crumbs';
import { RouterModule } from '@angular/router';
import { ServicesHeaderComponent } from './raksme.sheadersComponent';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



@NgModule({
  declarations: [
    ServicesHeaderComponent
  ],
  imports: [
    CommonModule,
    HeadersModule,
    BreadcrumbModule,
    RouterModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    ServicesHeaderComponent
  ]
})
export class ServiceHeadersModule { }
